import { ViewType } from './SidePanel';

interface ViewSelectorProps {
  title: string;
  view: ViewType;
  isSelected: boolean;
  handleViewSelection: (view: ViewType) => void;
  children?: React.ReactNode;
}

export const ViewSelector = ({
  view,
  isSelected,
  handleViewSelection,
  children = null
}: ViewSelectorProps) => {
  return (
    <button
      data-testid={`view-selector-${view}`}
      data-tour={`view-selector-${view}`}
      className={
        'flex-grow underline-effect ' +
        (isSelected ? 'border-b border-black' : 'border-none')
      }
      onClick={() => handleViewSelection(view)}
    >
      <div className="py-1">{children}</div>
    </button>
  );
};
